import {Breakpoints, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../types/generated/Tokens';

import {
  MuiInputLabel,
  MuiCheckbox,
  MuiHelperText,
  MuiTextField,
  MuiSelect,
  MuiFormControlLabel,
  MuiRadio,
  MuiButtons,
  MuiIconButtons,
  MuiLink,
  MuiBreadcrumbs,
  MuiSwitch,
  MuiTabs,
  MuiTypography,
  MuiChip,
  MuiContainer,
  MuiAccordion,
  MuiAccordionSummary,
  MuiAccordionDetails,
  MuiAutocomplete,
  MuiAlert,
  MuiPagination,
  MuiPaper,
  MuiPopover,
  MuiToggleButton,
  MuiStepper,
  MuiModal,
  MuiMenu,
  MuiSideNavigation,
  MuiDrawer,
  MuiLinearProgress
} from './component';

export const components = (tokens: Tokens, breakpoints: Breakpoints): ThemeOptions['components'] => ({
  ...MuiInputLabel(tokens, breakpoints),
  ...MuiCheckbox(tokens),
  ...MuiHelperText(tokens, breakpoints),
  ...MuiTextField(tokens),
  ...MuiSelect,
  ...MuiFormControlLabel(tokens, breakpoints),
  ...MuiRadio(tokens),
  ...MuiButtons(tokens, breakpoints),
  ...MuiIconButtons(tokens, breakpoints),
  ...MuiLink(tokens),
  ...MuiBreadcrumbs(tokens, breakpoints),
  ...MuiSwitch(tokens),
  ...MuiTabs(tokens),
  ...MuiTypography(tokens),
  ...MuiChip(tokens),
  ...MuiContainer(tokens, breakpoints),
  ...MuiAccordion(tokens, breakpoints),
  ...MuiAccordionSummary(tokens, breakpoints),
  ...MuiAccordionDetails(tokens, breakpoints),
  ...MuiAutocomplete(tokens),
  ...MuiAlert(tokens, breakpoints),
  ...MuiPagination(tokens, breakpoints),
  ...MuiPaper(tokens, breakpoints),
  ...MuiPopover(tokens, breakpoints),
  ...MuiToggleButton(tokens, breakpoints),
  ...MuiStepper(tokens, breakpoints),
  ...MuiModal(tokens, breakpoints),
  ...MuiMenu(tokens),
  ...MuiSideNavigation(tokens, breakpoints),
  ...MuiDrawer(tokens, breakpoints),
  ...MuiLinearProgress(tokens)
});
